import styled from 'styled-components/macro'
import { theme, ifProp } from 'styled-tools'
import { media, rem } from '../../utils/styles'

const color = ifProp('inverted', theme('colors.white'), theme('colors.base'))
const bgColor = ifProp('inverted', theme('colors.base'), theme('colors.white'));

const ArrowLink = styled.a`
  display: inline-block;
  text-decoration: none;
  color: ${color};
  font-weight: ${theme('fontWeights.bold')};
  line-height: 1.5;
  outline: 0;
  padding: 0 ${rem(7)};
  white-space: nowrap;
  transition: all 100ms ease-in;

  &::before {
    content: '\\003E';
    display: inline-block;
    margin-right: ${rem(10)};
    transition: transform 100ms ease-in;
  }

  &:focus {
    border-radius: ${rem(3)};
    color: ${bgColor};
    background-color: ${color};
  }

  &:not(:focus):hover::before {
    transform: translateX(3px);
  }

  ${media(`tablet`)`
    font-weight: ${theme('fontWeights.regular')};
  `}
`

export default ArrowLink
